<script setup>
import { down, edgeFromDtRange, maskStr, post } from '@/common/util'
import { useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import _ from 'lodash-es'
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
const {locale}=useI18n(),metaStore=useMetaStore(),meta=reactive({searchcols:[{tkey:'name',val:'mname'},{tkey:'email',val:'email'}],searchcol:'mname',data:{rows:[]}
  ,search:{dtrange:[new Date,new Date],sortcol:'cdt',isasc:true,page:1,size:15,where:{},dtcol:'cdt'}
  ,headers:[{tk:'dateofaccess',col:'cdt'},{tk:'connectionip',col:'ip'},{tk:'adminname',col:'mid'},{tk:'email',col:'email'},{tk:'accesspage',col:'accesspage'},{tk:'whatyoudo',col:'processtype'}]})
,sort=async(col)=>{
  if(meta.data.rows.length==0)return
  meta.search.isasc=!meta.search.isasc
  meta.search.sortcol=col
  await search()
},initPms=()=>{
  const pms={...meta.search,...edgeFromDtRange(meta.search.dtrange),page:meta.page?meta.page:1}
  pms.where.searchcol=meta.searchcol
  pms.where.searchval=meta.searchval
  return pms
},downExl=()=>{
  metaStore.blockLoading()
  down({url:'rest/authed/admin/downmemqueries',data:initPms()})
  setTimeout(() =>metaStore.blockLoading(false),2000)
},search=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/searchmemqueries',initPms())
  meta.data=res.data
  if(!meta.data)meta.data={rows:[]}
  meta.data.rows.forEach(row => {
    const mem=meta.data.subrows.mems.find(sub=>sub.mid==row.mid)
    row.mid=`${mem.mname}(${row.mid})`
    row.email=mem.email
  })
  metaStore.blockLoading(false)
}
meta.tblheight=window.innerHeight-505
</script>
<template>
  <div class="loghistory">
    <v-sheet class="pa-3 bg-grey-lighten-3">
      <v-row>
        <v-col cols="4">
            <v-date-input hide-details variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="$calendar" v-model="meta.search.dtrange" :label="$t('select_range')" multiple="range"/>
        </v-col>
        <v-col>
          <v-btn :text="$t('today')" class="me-2" @click="meta.search.dtrange=[new Date,new Date]"/>
          <v-btn :text="$t('yesterday')" class="me-2" @click="meta.search.dtrange=[dayjs().subtract(1,'day').toDate(),new Date]"/>
          <v-btn :text="$t('7daysago')" class="me-2" @click="meta.search.dtrange=[dayjs().subtract(7,'day').toDate(),new Date]"/>
          <v-btn :text="$t('30daysago')" @click="meta.search.dtrange=[dayjs().subtract(30,'day').toDate(),new Date]"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-select hide-details variant="outlined" density="compact" :items="meta.searchcols" v-model="meta.searchcol" :item-title="item=>$t(item.tkey)" item-value="val"/>
        </v-col>
        <v-col>
          <v-text-field hide-details variant="outlined" density="compact" :placeholder="$t('enteryoursearchterm')" v-model="meta.searchval"/>
        </v-col>
        <v-col>
          <v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/>
        </v-col>
        <v-spacer/>
      </v-row>
    </v-sheet>
    <v-sheet class="pa-3 bg-yellow-lighten-5">
      {{ $t('measuresnecessarytoensurethesecurityofpersonalinformation') }}
      <div v-if="locale=='kr'">
        개인정보의 기술적 관리적 보호조치 기준에 따라 정보통신서비스 제공자 들은 개인정보취급자가 개인정보취급처리시스템에 접속한 기록을 월 1회 이상 정기적으로 확인 감독하여야 하며,
        <br/>
        시스템 이상 유무의 확인 등을 위해서 최소 2년 이상 접속기록을 보관해야 합니다.
      </div>
    </v-sheet>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>{{ $t('memberinformationaccesshistory') }}</v-col>
          <v-col class="text-right"><v-btn :text="$t('downloadexcel')" @click="downExl" :disabled="meta.data.rows.length==0"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-table :height="meta.tblheight" fixed-header>
          <thead>
            <tr>
              <th class="text-left cursor-pointer" v-for="header in meta.headers" @click="sort(header.col)">{{ $t(header.tk) }}
                <v-icon v-if="meta.data.rows.length>0&&header.col==meta.sortcol" :icon="meta.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="meta.data.rows.length==0"><td :colspan="meta.headers.length" class="text-center">{{ $t('noresultsfound') }}</td></tr>
            <tr v-else v-for="row in meta.data.rows">
              <td v-for="header in meta.headers">
                <div v-if="header.col=='cdt'">{{ dayjs(row[header.col]).format('YYYY-MM-DD HH:mm') }}</div>
                <div v-else-if="header.col=='ip'||header.col=='email'">{{ maskStr(row[header.col],5) }}</div>
                <div v-else>{{ header.col=='mid'?row[header.col]:$t(row[header.col]) }}</div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-pagination class="ma-auto" v-if="meta.data.rows.length>0" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.page" @update:model-value="search"/>
      </v-card-actions>
    </v-card>
  </div>
</template>
<style>
.loghistory .v-input__control{background-color: rgba(255,255,255,1);}
</style>
